import type { JSX } from 'react'
import { turn } from '~/turns'

const pageImportByFeature: Record<
  string,
  () => Promise<{ default: () => JSX.Element }>
> = {
  trees: () =>
    import('~/features/trees/entry').then((mod) => ({ default: mod.Entry })),
  allowlist: () =>
    import('~/features/allowlist/page').then((mod) => ({ default: mod.Page })),
}

/**
 * Load the content of the feature this presentation selected.
 *
 * Daily's reveal condition is this promise resolving: the Suspense fallback
 * unmounts and sends `pageReady`. It is therefore the operation content
 * recovery re-enters, and it reads the already selected `turn.feature` rather
 * than choosing again, so a retry stays the same presentation.
 */
export function loadSelectedFeaturePage(): Promise<{
  default: () => JSX.Element
}> {
  return pageImportByFeature[turn.feature]()
}
